export default __webpack_public_path__ + "static/media/gallery11.9971025e.jpg";